import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-observaciones',
  templateUrl: './modal-observaciones.component.html',
  styleUrls: ['./modal-observaciones.component.scss']
})
export class ModalObservacionesComponent implements OnInit {

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('observacionesModal', { static: true }) observacionesModal: ModalDirective;

  // Form
  formData: FormGroup

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.createForm()
  }

  createForm() {
    this.formData = this.fb.group({
      observaciones: [null, [Validators.required, Validators.maxLength(300)]]
    });
  }

  show(cleanData: Boolean = false) {
    if (cleanData) {
      this.cleanAll()
    }
    this.observacionesModal.show();
  }

  hide() {
    this.observacionesModal.hide();
  }

  public cleanAll() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()

    this.initializeFormData()
  }

  private initializeFormData() {
    this.formData.get("observaciones").setValue(null)
  }

  /********* OPERATIONS *********/
  private validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  // Se consume desde la vista
  guardar() {
    this.validateAllFormFields(this.formData);
    if (!this.formData.valid)
      return
    //   const _factura = { ...factura }
    //   delete _factura.rutFormato
    //   // delete _producto.__typename
    //   this.onSelect.emit({
    //     data: _factura
    //   })
    this.onSelect.emit({
      data: this.formData.get("observaciones").value.trim()
    })
    this.hide()
  }

  /********* OPERATIONS *********/

}
